import React, {useState} from "react";
import {Box, Columns, Form, Heading} from "react-bulma-components";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import useButtonSelect from "../../hooks/useButtonSelect";
import ContactSection from "../Contact/ContactSection";
import DriverPicker from "../Settings/Driver/DriverPicker";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";
import axios from "axios";

const AsyncTypeahead = asyncContainer(Typeahead);

export default function MovementSupplierSection({data, onChange, onCheck, departments, onDepartmentChange, endpoint, onSearchedObjChange,
                                                    drivers, onDriverChange, onCustomerChange}){

    const [loading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [typeahead, setTypeahead] = useState();

    const handleCustomerChange = e => {
        // wrapper for more generic function
        onCustomerChange(e, "external_supplier")
    }

    const handleVehicleUsedChange = e => {
        onSearchedObjChange(e, "vehicle_used")
    }

    const handleVehicleSearch = query => {
        setLoading(true);
        axios
          .get(endpoint + `vehicles?showAll=true&search=${query}`)
          .then(resp => {
            setSearchData(resp.data.results);
            setLoading(false);
          });
    };

    const supplierStatusOptions = [
        {name: "Internal", value: "INTERNAL"},
        {name: "External", value: "EXTERNAL"}
    ];



    const [supplierStatus, supplierStatusInput] = useButtonSelect({
        label: "Supplier Status",
        initialValue: "INTERNAL",
        prop: "supplier_status",
        options: supplierStatusOptions,
        callback: onChange
    });



    return (
        <Box>
            <Columns>
                <Columns.Column>
                    <Heading>Movement Supplier Section</Heading>
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    {supplierStatusInput}
                </Columns.Column>
                <Columns.Column>
                    <DepartmentSelector
                        name={"movement_performer"}
                        label={"Supplier"}
                        value={data.movement_performer}
                        options={departments}
                        onChange={onDepartmentChange}
                        editable={true}
                        blank={true}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Driver Job Number</Form.Label>
                    <Form.Input
                        name={"driver_sequence_number"}
                        value={data.driver_sequence_number}
                        onChange={onChange}
                        type={"number"}
                    />
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Form.Label>Vehicle Used</Form.Label>
                    <AsyncTypeahead
                          useCache={false}
                          isLoading={loading}
                          id="typeahead"
                          labelKey="registration"
                          minLength={2}
                          name={"vehicle_used"}
                          onSearch={handleVehicleSearch}
                          onChange={handleVehicleUsedChange}
                          placeholder={`Search Vehicle`}
                          options={searchData}
                          ref={typeahead => setTypeahead(typeahead)}
                          className="typeahead"
                          selected={(data.vehicle_used && data.vehicle_used.id) ? [data.vehicle_used] : []}
                    />
                </Columns.Column>
                <Columns.Column>
                    <DriverPicker
                        label={"Driver"}
                        options={drivers}
                        onChange={onDriverChange}
                        editable={true}
                        blank={true}
                        value={data.driver}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Job Comments</Form.Label>
                    <Form.Textarea
                        name={"supplier_comments"}
                        value={data.supplier_comments}
                        onChange={onChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Work Complete</Form.Label>
                    <Form.Checkbox
                        checked={data.work_complete}
                        name={"work_complete"}
                        onChange={onCheck}
                    />
                </Columns.Column>
                {data.completed &&
                <Columns.Column>
                    <Form.Label invisible={true}>BLANK</Form.Label>
                    <Form.Input
                        value={"APPROVED"}
                        disabled={true}
                    />
                </Columns.Column>
                }
            </Columns>
            <Columns>
                <Columns.Column>
                    <Form.Label>Internal Charge</Form.Label>
                    <Form.Input
                        type={"number"}
                        value={data.internal_charge}
                        name={"internal_charge"}
                        onChange={onChange}
                        disabled={!data.supplier_cost_override}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Internal Charge Cost Override</Form.Label>
                    <Form.Checkbox
                        checked={data.supplier_cost_override}
                        name={"supplier_cost_override"}
                        onChange={onCheck}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Additional Internal Charge</Form.Label>
                    <Form.Input
                        name={"internal_additional_charge"}
                        value={data.internal_additional_charge}
                        onChange={onChange}
                        type={"number"}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Total Internal Charge</Form.Label>
                    <Form.Input
                        disabled={true}
                        value={parseFloat(data.internal_charge) + parseFloat(data.internal_additional_charge)}
                    />
                </Columns.Column>
            </Columns>
            {data.supplier_status === "EXTERNAL" &&
                <Columns>
                    <Columns.Column>
                        <ContactSection
                            title={"External Supplier"}
                            contactUpdate={handleCustomerChange}
                            endpoint={endpoint+"contacts"}
                            contact={data.external_supplier || {}}
                            type={"SP"}
                        />
                    </Columns.Column>
                </Columns>
            }
            {data.supplier_status === "EXTERNAL" &&
                <Columns>
                    <Columns.Column>
                        <Form.Label>External Supplier Charge</Form.Label>
                        <Form.Input
                            type={"number"}
                            name={"external_supplier_charge"}
                            value={data.external_supplier_charge}
                            onChange={onChange}
                            disabled={!data.external_supplier_charge_override}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>External Supplier Charge Override</Form.Label>
                        <Form.Checkbox
                            name={"external_supplier_charge_override"}
                            checked={data.external_supplier_charge_override}
                            onChange={onCheck}
                        />
                    </Columns.Column>
                </Columns>
            }
        </Box>
    )



}